import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuardService {

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const isUnderMaintenance = false;
    
    if (isUnderMaintenance) {
      this.router.navigate(['/under-maintenance']);
      return false;
    }
    return true;
  }
}
